/**
 * 견적 페이지 뒤로가기 이탈 방지 실험의 진입 유형 판정.
 *
 * 사이트 안: 이 문서 안에서 Next 클라이언트 라우팅으로 왔거나, referrer 가 고이 도메인(풀 페이지 이동).
 * 바로 진입: 그 외 전부. `document.referrer` 는 클라이언트 라우팅에서 바뀌지 않아 단독으로 못 쓴다.
 */

// `_app` 이 routeChangeStart 마다 켠다. 첫 문서 로드 직후에는 false 라서 바로 진입을 가린다.
let hasClientNavigated = false;

export const markClientNavigated = () => {
  hasClientNavigated = true;
};

const isGoiReferrer = (): boolean => {
  if (typeof document === "undefined" || !document.referrer) return false;
  try {
    const { host } = new URL(document.referrer);
    return host === window.location.host || host.endsWith("goifuneral.co.kr");
  } catch {
    return false;
  }
};

export const isInsideEntry = (): boolean => hasClientNavigated || isGoiReferrer();
